import React, { useState } from "react";
import { BarLoader } from "react-spinners";
import classNames from "classnames";
import { PulseLoader } from "..";
import DataTable from "../../../components/DataTable";
import { JonesRecord } from "../../../models";
import SettingIcon from "../../../shared/setting-icon";
import Banner from "../banner";
import { columns } from "../columns";
import NotLinkProject from "../notlink-project";
import ProjectOnboarding from "../project-onboarding";
import { Button } from "@procore/core-react";
import { Plus } from "@procore/core-icons/dist";
import CreateProjectRequest from "../create-request/create-project-request";
import CreateGlobalRequest from "../create-request/create-global-request";

interface IProjectGlobalSectionProps {
  intialData: any;
  isProjectOnboarding: boolean;
  projectName: string;
  vendorName: string;
  jonesVendorList: JonesRecord[];
  isValidating: boolean;
  userExist: any;
  loading: boolean;
  loadingiFrame: boolean;
  jonesGlobalVendor: JonesRecord[];
  isGlobalExits: boolean;
  isGlobalViewEnable: boolean;
  loadingGlobalJonesVendors: boolean;
  sidePanelVenodrId: string;
  onLoadIframe: () => void;
  onLoadJonesVendorsByProjetId: (procoreVendorId: string, resourceName: string) => void;
  onLoadGlobalJonesVendors: (procoreVendorId: string, resourceName: string, search: string) => void;
  commitmentType: string
}

const ProjectGlobalSection = ({
  intialData,
  isProjectOnboarding,
  projectName,
  vendorName,
  jonesVendorList,
  isValidating,
  userExist,
  loading,
  loadingiFrame,
  jonesGlobalVendor,
  isGlobalExits,
  isGlobalViewEnable,
  loadingGlobalJonesVendors,
  onLoadIframe,
  sidePanelVenodrId,
  onLoadJonesVendorsByProjetId,
  onLoadGlobalJonesVendors,
  commitmentType

}: IProjectGlobalSectionProps) => {
  const [showGlobalIframeLoader, setShowGlobalIframeLoader] =
    useState<boolean>(true);
  const [isCreatingProjectRequest, setIsCreatingProjectRequest] =
    useState<boolean>(false);
  const [isCreatingGlobalRequest, setIsCreatingGlobalRequest] =
    useState<boolean>(false);
  const [IscompanyId, SetiscompanyId] = useState<string>("");

  React.useEffect(() => {
    if (loadingiFrame) {
      setShowGlobalIframeLoader(true);
    }
  }, [loadingiFrame]);

  if (!intialData.kriyagoProjectId) {
    return <NotLinkProject projectName={projectName} />;
  } else if (isProjectOnboarding) {
    return <ProjectOnboarding projectName={projectName} />;
  } else {
    return (
      <>
        <div
          className="panel-header d-flex justify-content-between align-items-center mb-2"
          style={{ borderTop: "1px solid #ddd" }}
        >
          <div className="d-flex justify-content-start align-items-center sidepanel-x-padding">
            <SettingIcon />
            <span className="font-weight-bold pr-1">Project level -  {vendorName}</span>
           
          </div>
        </div>

        <div
          className={classNames(
            "d-flex flex-column ",
            jonesVendorList?.length ? "align-items-start" : "align-items-center"
          )}
          style={{ minHeight: "70vh" }}
        >
          <>
            {jonesVendorList?.length ? (
              <div className="d-flex flex-column">
                {isValidating ? (
                  <PulseLoader />
                ) : (
                  <>
                    {userExist?.userexist && userExist?.recordHubExist && (
                      <Banner />
                    )}

                    <div className="sidepanel-x-padding">
                      <DataTable
                        id="gridContainer"
                        dataSource={jonesVendorList}
                        keyExpr="id"
                        columns={columns}
                        loading={loading}
                        pageSize={5}
                      />
                    </div>

                    {jonesVendorList[0].complainceReportLink && (
                      <div
                        className="my-2 d-flex flex-column justify-content-start align-items-center"
                        style={{
                          height: !!jonesGlobalVendor.length ? "55vh" : "58vh",
                        }}
                      >
                        {loadingiFrame ? (
                          <BarLoader color="#ddd" width={375} />
                        ) : (
                          <></>
                        )}

                        <iframe
                          src={jonesVendorList[0].complainceReportLink}
                          title="description"
                          style={{
                            width: "375px",
                            borderTop: "1px solid #ddd",
                            borderLeft: "1px solid #ddd",
                            flex: 1,
                          }}
                          loading="lazy"
                          className={loadingiFrame ? "skeleton" : ""}
                          onLoad={() => {
                            onLoadIframe();
                          }}
                          height={"auto"}
                        ></iframe>
                      </div>
                    )}
                  </>
                )}
              </div>
            ) : !isCreatingProjectRequest ? (
              <div className="d-flex justify-content-center flex-column align-items-center sidepanel-x-padding">
                {userExist?.userexist && userExist?.recordHubExist && (
                  <div className="mt-2">
                    <Banner />
                  </div>
                )}
                <div
                  className="d-flex mb-2 align-items-center font-weight-normal"
                  style={{ minHeight: "50px", color: "#363A43" }}
                >
                  No COI request initiated
                </div>

                <div className="d-flex justify-content-center no-gutters">
                  <div>
                    <Button
                      icon={<Plus />}
                      onClick={() => {
                        setIsCreatingProjectRequest(true);
                      }}
                      className="add-vendor-btn"
                    >
                      Add Project COI Request
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <CreateProjectRequest
                showCOIModal={true}
                commitmentType={commitmentType}
                onSaved={() => {}}
                setIsShowModal={setIsCreatingProjectRequest}
                IscompanyId={IscompanyId}
                sidePanelVenodrId={sidePanelVenodrId}
                onClose={(isRequestCreated) => {
                  setIsCreatingProjectRequest(false);
                  if(isRequestCreated){
                    onLoadJonesVendorsByProjetId(sidePanelVenodrId, commitmentType);
                  }
                }}
              />
            )}
          </>
        </div>

        <div className="panel-footer mt-1">
          <>
            {isGlobalExits && isGlobalViewEnable && (
              <>
                <div
                  className="d-flex justify-content-start align-items-center panel-header my-1 sidepanel-x-padding"
                  style={{ borderTop: "1px solid #ddd" }}
                >
                  <SettingIcon />
                  <span className="font-weight-bold  pr-1">
                    Company level -  {vendorName}
                  </span>
                 
                </div>

                {jonesGlobalVendor.length ? (
                  <div className="d-flex flex-column mt-2">
                    <div className="sidepanel-x-padding">
                      <DataTable
                        id="gridContainer"
                        dataSource={jonesGlobalVendor}
                        keyExpr="id"
                        columns={columns}
                        loading={loadingGlobalJonesVendors}
                        pageSize={5}
                      />
                    </div>

                    {jonesGlobalVendor[0].complainceReportLink && (
                      <div className="my-2 d-flex flex-column justify-content-start align-items-center">
                        {showGlobalIframeLoader ? (
                          <BarLoader color="#ddd" width={375} />
                        ) : (
                          <></>
                        )}
                        <iframe
                          src={jonesGlobalVendor[0].complainceReportLink}
                          title="description"
                          className={showGlobalIframeLoader ? "skeleton" : ""}
                          style={{
                            width: "375px",
                            borderTop: "1px solid #ddd",
                            borderLeft: "1px solid #ddd",
                            height: "450px",
                          }}
                          onLoad={() => {
                            setShowGlobalIframeLoader(false);
                          }}
                        ></iframe>
                      </div>
                    )}
                  </div>
                ) : !isCreatingGlobalRequest ? (
                  <div
                    className="d-flex justify-content-center flex-column align-items-center  sidepanel-x-padding"
                    style={{ minHeight: "100px" }}
                  >
                    <div
                      className="my-4  font-weight-normal"
                      style={{ color: "#363A43" }}
                    >
                      No COI request initiated
                    </div>
                    <div className="d-flex justify-content-center no-gutters">
                      <div className="my-2">
                        <Button
                          icon={<Plus />}
                          onClick={() => {
                            setIsCreatingGlobalRequest(true);
                          }}
                          className="add-vendor-btn"
                        >
                          Add Global COI Request
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <CreateGlobalRequest
                    showCOIModal={true}
                    commitmentType={commitmentType}
                    onSaved={() => {}}
                    sidePanelVenodrId={sidePanelVenodrId}
                    setIsShowModal={setIsCreatingGlobalRequest}
                    onClose={(isRequestCreated) => {
                      setIsCreatingGlobalRequest(false);
                      if(isRequestCreated){
                        onLoadGlobalJonesVendors(sidePanelVenodrId, commitmentType,'')
                      }
                    }}
                  />
                )}
              </>
            )}
          </>
          <div className=" text-center" style={{ padding: "5px 10px" , marginTop: '8%', borderTop: "1px solid #ddd" }}>
            <div className="font-weight-bold" style={{ color: "#8995AD" }}>
              Powered by JONES{" "}
            </div>
            <div className="text-sm">
              <a
                rel="noopener noreferrer"
                href="http://getjones.com"
                target="_blank"
                style={{ color: "#0073FF" }}
              >
                www.getjones.com
              </a>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default ProjectGlobalSection;
